<template>
    <div class="bg-wrap">
        <Banner></Banner>
        <div class="content">
            <label>专家评审</label>
            <div class="input-wrap">
                <input type="text" placeholder="请输入姓名" v-model="name">
                <input type="text" placeholder="请输入手机号" v-model="phone">
                <span @click="toCase">登录</span>
            </div>
        </div>
        <div class="bottom">
            <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/bottom_1.png">
        </div>
    </div>

</template>

<script>
    import Banner from "@/components/ksd/fragment/Banner";
    import {ksdJudgeLogin} from "@/assets/js/api";

    export default {
        name: "JudgeLogin",
        data(){
            return{
                name:"",
                phone:""
            }
        },
        methods:{
            toCase(){
                if(this.name==""){
                    this.$toast("请填写姓名")
                    return
                }
                if(this.phone==""){
                    this.$toast("请填写手机号")
                    return
                }
                this.login(this.name,this.phone)
            },
            async login(name,phone){
                const res = await ksdJudgeLogin({name,phone});
                if(res.data.success){
                    this.$store.state.ksd_judgeId=res.data.data.judgeId
                    this.$router.push("judgeCase")
                }else{
                    this.$toast(res.data.message)
                }
            }
        },
        components:{
            Banner
        }
    }
</script>

<style scoped lang="scss">
    .bg-wrap {
        width: 100%;
        height: 100vh;
        background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/bg.png") no-repeat;
        background-size: 100% 100%;
        font-size: 16px;
        display: flex;
        flex-flow: column;

    }
    .bottom{
        width: 100%;
        flex-grow: 1;
        display: flex;
        align-items: flex-end;
        justify-content: flex-end;

        img{
            display: block;
            max-width: 70%;
            object-fit: contain;
        }
    }
    .content{
        display: flex;
        flex-flow: column;
        /*justify-content: center;*/
        align-items: center;
        .input-wrap{
            width: 80%;
            margin: 0 auto;
        }
        input{
            display: block;
            height: 30px;
            border: none;
            outline: none;
            width: 100%;
            margin-bottom: 6px ;
            background: #E6E6E6;
            border-radius: 10px;
            text-indent: 10px;
            font-size: 16px;
            padding: 2px 0;
        }
        label{
            color: #156098;
            font-size: 20px;
            font-weight: bold;
            margin-bottom: 10px;
        }
        span{
            width: 100%;
            display: block;
            background: #156098;
            color: #FFF;
            height: 32px;
            line-height: 32px;
            border-radius: 5px;
        }
    }
</style>